module.exports = __WEBPACK_EXTERNAL_MODULE__webhandle_backbone_view_374f7d04__;